<template>
    <div class="ProcessSubview">
        <QCard
            bordered
            class="ProcessSubviewCard"
        >
            <QCardSection class="q-pa-none">
                <Visualization
                    v-bind="$attrs"
                    ref="visualization"
                    :processId="processId"
                    :infoTotal="infoTotal"
                    :infoFiltered="infoFiltered"
                    :attributes="attributes"
                    :categoricalAttributes="categoricalAttributes"
                    :numericAttributes="numericAttributes"
                    :hideTabs="hideTabs"
                    :forcedTab="forcedTab"
                    @display-state-changed="$emit('display-state-changed', $event)"
                />
            </QCardSection>
        </QCard>
    </div>
</template>

<script>
import VueTypes from 'vue-types'
import Visualization from '../Visualization/Visualization.vue'

export default {
    name: 'VisualizationSubview',
    components: { Visualization },
    inheritAttrs: false,
    props: {
        processId: VueTypes.any,
        infoTotal: VueTypes.object,
        infoFiltered: VueTypes.object,
        attributes: VueTypes.array,
        categoricalAttributes: VueTypes.array,
        numericAttributes: VueTypes.array,
        forcedTab: VueTypes.string,
        hideTabs: VueTypes.bool.def(true),
    },
    methods: {
        getDisplayState() {
            return this.$refs.visualization?.getDisplayState?.()
        },
        getFrequencyIndicatorState() {
            return this.$refs.visualization?.getFrequencyIndicatorState?.()
        },
        reloadCurrentView() {
            this.$refs.visualization?.reloadCurrentView?.()
        },
        handleCenterChart() {
            this.$refs.visualization?.handleCenterChart?.()
        },
        openSaveBpmn() {
            this.$refs.visualization?.openSaveBpmn?.()
        },
        setPercentageModeValue(value) {
            this.$refs.visualization?.setPercentageModeValue?.(value)
        },
        setDirectionValue(value) {
            this.$refs.visualization?.setDirectionValue?.(value)
        },
        setStatsValue(value) {
            this.$refs.visualization?.setStatsValue?.(value)
        },
        setHeatmapModeValue(value) {
            this.$refs.visualization?.setHeatmapModeValue?.(value)
        },
        handleSetChart(data) {
            this.$refs.visualization?.handleSetChart?.(data)
        },
        handleColorChartLoops(data) {
            this.$refs.visualization?.handleColorChartLoops?.(data)
        },
        handleRequestModelInfo(data) {
            this.$refs.visualization?.handleRequestModelInfo?.(data)
        },
        loadingControl(load) {
            this.$refs.visualization?.loadingControl?.(load)
        },
        handleResetModel() {
            this.$refs.visualization?.handleResetModel?.()
        },
        handleChangeVariantTab(newVariantTab) {
            this.$refs.visualization?.handleChangeVariantTab?.(newVariantTab)
        },
        handleChangedVariant() {
            this.$refs.visualization?.handleChangedVariant?.()
        },
        handleIncreaseFrequencyIndicator() {
            this.$refs.visualization?.handleIncreaseFrequencyIndicator?.()
        },
        handleDecreaseFrequencyIndicator() {
            this.$refs.visualization?.handleDecreaseFrequencyIndicator?.()
        },
    },
}
</script>

<style scoped lang="scss">
.ProcessSubview {
    height: 100%;
}

.ProcessSubviewCard {
    height: 100%;
    background: $gray-bg;
}
</style>
